import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontFamilies,
  fontSizes,
  fontWeights,
}: Theme) => ({
  filtersTypeTitle: {
    margin: '0 0 0.75rem',
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.lg,
    fontWeight: fontWeights.medium,
    lineHeight: 1.4,
  },
  c2cButtonStyles: {
    '&:last-of-type': {
      display: 'block',
    },
  },
  c2cGroupStyles: {
    '&&': {
      display: 'flex',
    },
  },
}));
